import { createStore, combineReducers, applyMiddleware } from "redux"
import thunk, { ThunkAction, ThunkDispatch } from "redux-thunk"
import { composeWithDevTools } from "redux-devtools-extension"
import { userReducer } from "./user/reducers"
import { redirectionReducer } from "./redirection/reducers"
import {
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from "react-redux"
import { Action } from "redux"
import { Service } from "axios-middleware"
import axios, { AxiosRequestConfig } from "axios"
import { dataReducer } from "./data/reducers"
import { permissionsReducer } from "./permissions/reducers"
const rootReducers = combineReducers({
  user: userReducer,
  redirection: redirectionReducer,
  data: dataReducer,
  permissions: permissionsReducer,
})

export type AppState = ReturnType<typeof rootReducers>

//#region store creation
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const middlewares = [thunk]
const middleWareEnhancer = applyMiddleware(...middlewares)
const store = createStore(rootReducers, composeWithDevTools(middleWareEnhancer))
//#endregion

export default function configureStore() {
  return store
}

export const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector

export type ThunkResult<R> = ThunkAction<R, AppState, undefined, Action>

export type PromiseDispatch<T> = ThunkDispatch<
  AppState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Action<Promise<T>>
>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DispatchType = ThunkDispatch<AppState, any, Action<any>>

export const storage = window.localStorage

const service = new Service(axios)

service.register({
  onRequest(config: AxiosRequestConfig) {
    const token = storage.getItem("loginKey")
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    }
    return config
  },
})
